import React from 'react';

/**
 * Return true if element title should be visually hidden.
 */
export function isTitleHidden(webformAttributes) {
  return webformAttributes.title_display === 'invisible';
}

export function getTileStyle(webformAttributes) {
  if (isTitleHidden(webformAttributes)) {
    return {
      position: 'absolute',
      overflow: 'hidden',
      clip: 'rect(1px,1px,1px,1px)',
      width: '1px',
      height: '1px',
      wordWrap: 'normal',
    };
  }
  return undefined;
}

export function getTitleDisplay(webformAttributes) {
  return webformAttributes.title_display === 'after' ? 'after' : 'before';
}

export function isElementHidden(states) {
  return states.invisible === true || states.visible === false;
}

function classNames(list) {
  const className = list.filter((item) => typeof item === 'string').join(' ');
  return className.length > 0 ? className : undefined;
}

const ElementWrapper = ({
                          children,
                          settings,
                          error,
                          labelFor,
                          labelClassName,
                          ...props
                        }) => {
  const {states, attributes} = settings;
  const wrapperClassNames = classNames([
    'vl-form-col--1-1',
    error != null && 'is-invalid',
    props.className,
    attributes.wrapper_class,
  ]);
  // todo: pass required prop here and add css class 'required' etc. to label.
  const labelClassNames = classNames([labelClassName, attributes.label_class]);
  if (states && isElementHidden(states)) {
    return <></>;
  }
  const label = (
    <label
      style={getTileStyle(attributes)}
      className={labelClassNames}
      htmlFor={labelFor}
    >
      {attributes.title}
      {settings.attributes.required ? <></> : (
        <span className="vl-form__label__optional">(optioneel)</span>
      )}
    </label>
  );
  return (
    <div {...props} className={wrapperClassNames}>
      {getTitleDisplay(attributes) === 'before' && label}

      {attributes.description && (
        <div
          className="vl-form__annotation"
          {...props}
          dangerouslySetInnerHTML={{__html: attributes.description}}
        />
      )}

      {children}

      {getTitleDisplay(attributes) === 'after' && label}

      {error && (
        <div className="form-text invalid-feedback" {...props}>
          {error}
        </div>
      )}
    </div>
  );
};

export default ElementWrapper;
